export const ALL_AUDIENCE = 'ALL';

export const MAX_AUDIENCE_VALUES = 30;
export const MAX_AUDIENCES_PER_USER = MAX_AUDIENCE_VALUES - 1;

export type Audience = {
  id: string;
  name: string;
  nameEN: string;
  description: string;
  isActive: boolean;
  createdAt?: { seconds: number | undefined };
  createdBy?: string;
};

export type AudienceFormData = {
  name: string;
  nameEN: string;
  description: string;
  isActive: boolean;
};
